import { useState } from "react";
import { FaEllipsisV } from 'react-icons/fa';
import axiosInstance from "../../api/axiosInstance";
import API_ENDPOINTS from "../../api/endpoints";
import { toast } from 'react-toastify';
import { FaCalendarAlt, FaClock, FaTrophy, FaMapMarkerAlt } from "react-icons/fa";
import { ThreeDots } from 'react-loader-spinner';


export default function PokerGamesTable({ games }) {
  const [gameDetails, setGameDetails] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [showMenu, setShowMenu] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleGameDetails = async (game) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.GAME_DETAILS}?id=${game.id}`);
      setGameDetails(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching game details:", error);
      toast.error("Failed to fetch game details");
      setLoading(false);
    }
    setShowDialog(true);
    setShowMenu(null);
  }

  return (
    <div className="p-4">
      {loading &&
        <ThreeDots
          visible={true}
          height="80"
          width="80"
          color="#1976d2"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass="dots-loading additional-class"
        />
      }
      <div className="overflow-x-auto overflow-y-visible w-full text-nowrap">
        <table className="w-full text-sm text-left text-white  ">
          <thead className="bg-black border-b border-gray-700">
            <tr>
              <th className="p-3">Game</th>
              <th className="p-3">P/L</th>
              <th className="p-3">Balance</th>
              <th className="p-3">Buy In</th>
              <th className="p-3">Cash Out</th>
              <th className="p-3">Incidentals</th>
              <th className="p-3">Side Games </th>
              <th className="p-3">Game Type</th>
              <th className="p-3">Date</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {games.map((game, index) => (
              <tr key={index} className="border-b border-gray-800">
                <td className="p-3">
                  <div className="font-medium">{game.gameName}</div>
                  <div className="text-xs text-gray-400">{game.gameVarient}</div>
                </td>
                <td className={`p-3 ${String(game.pl).startsWith('-') ? 'text-red-400' : 'text-green-400'}`}>{game.pl}</td>
                <td className={`p-3 ${String(game.balance).startsWith('-') ? 'text-red-400' : 'text-green-400'}`}>{game.balance}</td>
                <td className="p-3">{game.buyIn}</td>
                <td className="p-3">{game.cashOut}</td>
                <td className="p-3">{game.incidentals}</td>
                <td className={`p-3 ${String(game.subGameBal).startsWith('-') ? 'text-red-400' : 'text-green-400'}`}>{game.subGameBal}</td>
                <td className="p-3">
                  <span className={`px-3 py-1 text-xs rounded-full ${game.gameType === "Tournament" ? "bg-blue-800" :
                    game.gameType === "Cash" ? "bg-green-800" : "bg-gray-700"
                    }`}>{game.gameType}</span>
                </td>
                <td className="p-3">{game.date}</td>
                <td className="p-3 relative">
                  <button
                    className="p-3 hover:bg-gray-800 rounded"
                    onClick={() => setShowMenu(showMenu === index ? null : index)}
                  >
                    <FaEllipsisV />
                  </button>
                  {showMenu === index && (
                    <div className="absolute bottom-0  p-1 right-20 z-10 mt-2 w-28 bg-black border border-gray-700 rounded shadow-lg">
                      <button
                        className="w-full px-4 py-2 text-left hover:bg-gray-800"
                        onClick={() => handleGameDetails(game)}
                      >
                        Details
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showDialog && gameDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 px-3 flex items-center justify-center z-[99999]">
          <div className="border border-border bg-[#0a0a0a] md:p-8 p-4 rounded-lg h-[90vh] overflow-auto w-full max-w-xl text-white relative shadow-lg">
            {/* Close button */}
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-white text-xl"
              onClick={() => setShowDialog(false)}
              aria-label="Close"
            >
              &#10005;
            </button>
            {/* Header */}
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl" ><FaTrophy className="text-blue-400" /></span>
              <h2 className="text-2xl font-bold">{gameDetails.gameName || "-"}</h2>
            </div>
            {/* Info Row */}
            <div className="flex flex-wrap justify-between text-zinc-300 mb-4">
              <div className="flex items-start flex-col gap-2">
                <div className="flex items-center gap-2">
                  <span><FaCalendarAlt /></span>
                  <span>{gameDetails.gameDate || "-"}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span><FaMapMarkerAlt /></span>
                  <span>{gameDetails.gameLocation || "-"}</span>
                </div>
              </div>
              <div className="flex items-start flex-col gap-2">
                <div className="flex items-center gap-2">
                  <span><FaClock /></span>
                  <span>{gameDetails.gameDuration || "-"}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span>Type:</span>
                  <span className="font-semibold">{gameDetails.gameType || "-"}</span>
                </div>
              </div>
            </div>
            {/* Financial Summary */}
            <div className="border border-border bg-[#0a0a0a] rounded mb-6 p-4 ">
              <div className="font-semibold mb-2">Financial Summary</div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <div className="text-zinc-400 text-xs">Buy In</div>
                  <div className="font-bold">
                    {gameDetails.buyIn ? `$${parseFloat(gameDetails.buyIn).toLocaleString()}` : "-"}
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Cash Out</div>
                  <div className="font-bold">
                    {gameDetails.cashout !== null && gameDetails.cashout !== undefined
                      ? `$${parseFloat(gameDetails.cashout).toLocaleString()}`
                      : "-"}
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Profit/Loss</div>
                  <div className={`font-bold ${String(gameDetails.pl).startsWith('-') ? 'text-red-400' : 'text-green-400'}`}>
                    {gameDetails.pl
                      ? `${String(gameDetails.pl).startsWith('-') ? '-' : '+'}$${Math.abs(parseFloat(gameDetails.pl)).toLocaleString()}`
                      : "-"}
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Side Game Buy In</div>
                  <div className={`font-bold `}>
                    ${gameDetails.subBuy}
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Side Game Cash Out</div>
                  <div className={`font-bold `}>
                    ${gameDetails.subCash}
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Incidentals</div>
                  <div className={`font-bold `}>
                    {gameDetails.incidentals}
                  </div>
                </div>
              </div>
            </div>
            {/* Session Details */}
            <div className="border border-border bg-[#0a0a0a] rounded mb-6 p-4 ">
              <div className="font-semibold mb-2">Session Details</div>
              <div className="mb-3">
                <div className="text-zinc-400 text-xs mb-1">Game Summary</div>
                <div className="text-white">{gameDetails.sessionSummary || "-"}</div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div>
                  <div className="text-zinc-400 text-xs">Difficulty</div>
                  <div className="flex items-center gap-1">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span key={i} className={`${i < Number(gameDetails.sessionDifficulty) ? 'text-yellow-500' : 'text-gray-300'}`}>{i < Number(gameDetails.sessionDifficulty) ? "★" : "☆"}</span>
                    ))}
                    <span className="ml-1 text-xs text-zinc-400">({gameDetails.sessionDifficulty || 0}/5)</span>
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Session Rating</div>
                  <div className="flex items-center gap-1">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span key={i} className={`${i < Number(gameDetails.sessionRating) ? 'text-yellow-500' : 'text-gray-300'}`}>{i < Number(gameDetails.sessionRating) ? "★" : "☆"}</span>
                    ))}
                    <span className="ml-1 text-xs text-zinc-400">({gameDetails.sessionRating || 0}/5)</span>
                  </div>
                </div>
                <div>
                  <div className="text-zinc-400 text-xs">Headspace</div>
                  <div className="flex items-center gap-1">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span key={i} className={`${i < Number(gameDetails.sessionHeadspace) ? 'text-yellow-500' : 'text-gray-300'}`}>{i < Number(gameDetails.sessionHeadspace) ? "★" : "☆"}</span>
                    ))}
                    <span className="ml-1 text-xs text-zinc-400">({gameDetails.sessionHeadspace || 0}/5)</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Session Notes */}
            <div className="border border-border bg-[#0a0a0a] rounded p-4 ">
              <div className="font-semibold mb-1">Session Notes</div>
              <div className="text-zinc-300">{gameDetails.sessionNotes || <span className="italic text-zinc-500">No notes</span>}</div>
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setShowDialog(false)}
                className="px-6 py-2 border border-gray-600 rounded hover:bg-border "
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
